import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { LANGUAGES, changeLanguage } from "../i18n";
import "./LanguageSelect.css";

// Language dropdown. Uses a native <select> so Android WebViews open their own picker.
// variant: "glass" (on the blue login header) or "card" (in the sidebar)
const LanguageSelect = ({ variant = "card", className = "" }) => {
  const { t, i18n } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language;

  return (
    <label className={`lang-select lang-select--${variant} ${className}`}>
      <FontAwesomeIcon icon={faGlobe} className="lang-select-globe" aria-hidden="true" />
      <select
        className="lang-select-input"
        value={current}
        onChange={(e) => changeLanguage(e.target.value)}
        aria-label={t("language.label")}
      >
        {LANGUAGES.map((language) => (
          <option key={language.code} value={language.code} lang={language.code}>
            {language.name} ({language.native})
          </option>
        ))}
      </select>
      <FontAwesomeIcon icon={faChevronDown} className="lang-select-chevron" aria-hidden="true" />
    </label>
  );
};

export default LanguageSelect;
